import { useState } from 'react';
import { api } from '../auth/api.js';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onClick = async () => {
    setLoading(true);
    setError(null);
    try {
      // Return to /auth/callback so AuthCallback can read the token fragment;
      // from there it refreshes the auth context and navigates to `/`.
      const returnTo = `${window.location.origin}/auth/callback`;
      const { url } = await api<{ url: string }>(
        `/auth/login?returnTo=${encodeURIComponent(returnTo)}`
      );
      window.location.href = url;
    } catch (err) {
      setLoading(false);
      setError(err instanceof Error ? err.message : 'Login failed');
    }
  };

  return (
    <main className="grid min-h-screen place-items-center px-6">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-bold tracking-tight">ล.สามไทย · Ops</h1>
        <p className="mt-1 text-sm text-slate-500">
          ระบบจัดการ stock ภายใน (admin เท่านั้น)
        </p>
        <button
          onClick={onClick}
          disabled={loading}
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-[#06c755] px-4 py-3 font-semibold text-white transition hover:bg-[#05b74c] disabled:opacity-60"
        >
          {loading ? 'กำลังไป LINE...' : 'Login with LINE'}
        </button>
        {error && (
          <p className="mt-3 text-sm text-red-600">{error}</p>
        )}
      </div>
    </main>
  );
}
